import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("span", { staticStyle: { visibility: "hidden" } }, [
        _vm._v(
          " ----------------------------------------------------------------------------------------------------------- "
        ),
      ]),
      _c(VTreeview, {
        attrs: { items: _vm.legenda, dense: "", "open-on-click": "" },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function ({ item }) {
              return [
                item.root
                  ? _c(
                      "span",
                      {
                        staticClass: "font-weight-bold caption",
                        attrs: { width: "300" },
                      },
                      [_vm._v(_vm._s(item.nome))]
                    )
                  : _c("span", { staticClass: "caption" }, [
                      _c(
                        "span",
                        {
                          staticClass: "font-weight-bold",
                          style: `color: ${item.color}`,
                        },
                        [_vm._v(_vm._s(item.descricao) + ": ")]
                      ),
                      _vm._v(_vm._s(item.descricaoAcao) + " "),
                    ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }